import React from 'react';
import { hasBrandImage, hasRoundel } from '../../components/PromoIconography/promotionUtilities';
import PromoIconography from '../../components/PromoIconography';
import { generateSizesByBreakpoint } from '../../components/Image/generateSizesByBreakpoint';
import { buildSrcSet } from '../../components/Image/Sources';
import { buildUrl } from '../../utils/build-url';
import { useConfig } from '../../config/ContentComponentLibraryProvider';
import styles from './index.scss';
const hasMyWaitrose = (icons) => { var _a; return !!((_a = icons === null || icons === void 0 ? void 0 : icons.myWaitroseIcon) === null || _a === void 0 ? void 0 : _a.display); };
const isSupercharged = (icons) => { var _a, _b; return !!((_b = (_a = icons === null || icons === void 0 ? void 0 : icons.myWaitroseIcon) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.supercharged); };
const PromoImagery = ({ hideMessage = false, icons = null, image = null, externalImageSrc = false, imageRef = null, lazyLoad = true, }) => {
    const config = useConfig();
    let wrapperClass = styles.wrapper;
    if (icons) {
        if (hasBrandImage(icons)) {
            if (hasMyWaitrose(icons) && hasRoundel(icons)) {
                wrapperClass = styles.bannerWithBrand;
            }
            if (isSupercharged(icons)) {
                wrapperClass = styles.superchargedWithBrand;
            }
        }
    }
    const { portraitImage, landscapeImage } = image || {};
    const renderImage = (img, style) => {
        var _a;
        const dynamicImages = img === null || img === void 0 ? void 0 : img.dynamicImages;
        const loadingProp = lazyLoad ? 'lazy' : undefined;
        if (dynamicImages) {
            return (React.createElement("img", { ref: imageRef, height: img === null || img === void 0 ? void 0 : img.assetMetadataHeight, width: img === null || img === void 0 ? void 0 : img.assetMetadataWidth, srcSet: buildSrcSet((_a = img === null || img === void 0 ? void 0 : img.dynamicImages) === null || _a === void 0 ? void 0 : _a.highQuality95), alt: img.altText, loading: loadingProp, sizes: generateSizesByBreakpoint({
                    fallback: '75vw',
                    xs: '100vw',
                }), className: style }));
        }
        if (img === null || img === void 0 ? void 0 : img.src) {
            return (React.createElement("img", { ref: imageRef, height: img === null || img === void 0 ? void 0 : img.assetMetadataHeight, width: img === null || img === void 0 ? void 0 : img.assetMetadataWidth, src: `${buildUrl(img.src, externalImageSrc, config.cfDomain)}`, alt: img.altText, loading: loadingProp, className: style }));
        }
        return null;
    };
    return (React.createElement("div", { "data-testid": "promo-imagery", className: wrapperClass },
        React.createElement("div", { className: styles.imageWrapper },
            renderImage(portraitImage, styles.portrait),
            renderImage(landscapeImage, styles.landscape),
            React.createElement(PromoIconography, { icons: icons, hideMessage: hideMessage }))));
};
export default PromoImagery;
//# sourceMappingURL=index.js.map